export default "__VITE_ASSET__c5274315__"